import React from 'react'
import BaseLevel from './base.levels'
import { BaseLevelLayoutComponent, DotsGridComponent } from '../level.components'
import dotsUtils from './utils/dots.utils'
import numberUtils from './utils/number.utils'
import { buildLevel } from '../../../services/game.services'


export default class DotsLevelComponent extends BaseLevel {

    onEnter = () => {
        if (+this.state.answer === +this.state.quantities.value_1) {
            this.setState({ wrongAnswer: false, answer: '?' })
            this.props.onRoundComplete()
            this.generateLevel()
            this.onRoundComplete()
        } else {
            this.setState({ wrongAnswer: true, answer: '?' })
            this.props.onRoundFail()
            this.onRoundFail()
        }
    }
    generateLevel = (newConfig = true, width = null, height = null) => {
        const levelConfig = newConfig ? buildLevel(this.props.level) : this.state.levelConfig
        const quantities = levelConfig.quantities
        const level = this.props.level
        const settings = level.settings
        const answer = this.state.answer
        const gameContainerWidth = !isNaN(width) && width !== null ? width : this.state.gameContainerWidth
        const gameContainerHeight = !isNaN(height) && height !== null ? height : this.state.gameContainerHeight
        const dotsLayout = (dotsUtils.getLevelLayout(gameContainerWidth, gameContainerHeight, settings, quantities, answer, newConfig))
        this.setState({ levelConfig, ...levelConfig, dotsLayout })
    }
    updateDimensions = (clear = false) => {
        if (clear === true) {
            this.setState({
                gameContainerWidth: 0,
                gameContainerHeight: 0
            })
            this.generateLevel(false, 0, 0)
        } else {
            if (this.refs.level) {
                this.setState({
                    gameContainerWidth: this.refs.level.parentNode.clientWidth,
                    gameContainerHeight: this.refs.level.parentNode.clientHeight
                })
                this.generateLevel(false, this.refs.level.parentNode.clientWidth, this.refs.level.parentNode.clientHeight)
            }
        }
    }
    render() {
        const level = this.props.level
        const stage = this.props.stage
        const answer = this.state.answer
        const wrongAnswer = this.state.wrongAnswer
        return (
            <BaseLevelLayoutComponent level={level} togglePause={this.props.togglePause} updateDimensions={this.updateDimensions} progress={this.props.progress || 0} stage={stage} answer={answer} wrongAnswer={wrongAnswer} userBot={this.props.userBot} onRefresh={this.onRefresh} score={this.props.score} flash={this.state.flash} instruction={level.instruction} onExit={this.props.onExit} onUpdate={this.onUpdate} onEnter={this.onEnter}>
                <div ref="level" className='level'>
                    {this.state.dotsLayout || null}
                </div>
            </BaseLevelLayoutComponent>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/game/levels/dots.levels.js